// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SectionHeader_sectionHeader__lCYv5","title":"SectionHeader_title__1YUhN","lede":"SectionHeader_lede__XnC3s","centered":"SectionHeader_centered__FI8c4"};